import {
  getCountryApiParam,
  getIsoCountry,
  type IsoCountry,
  type LegacyCountryToken,
} from '../../i18n/country';
import { usePlatformLanguage } from './usePlatformLanguage';

/**
 * The ISO 3166-1 alpha-2 country for the active platform — `GB` on the UK platform.
 *
 * Use this for anything that stays inside the browser: comparisons, keying a lookup table, choosing
 * a taxonomy. For a value going to the API use {@link useCountryApiParam} instead.
 */
export const usePlatformIsoCountry = (): IsoCountry =>
  getIsoCountry(usePlatformLanguage());

/**
 * The `country` value to send to the API for the active platform — `UK` on the UK platform, because
 * that is what the stored data says. See `toLegacyCountryToken` for why, and for when this can go.
 *
 * Use this only where the value leaves the browser, as a request param or a payload field.
 */
export const useCountryApiParam = (): LegacyCountryToken =>
  getCountryApiParam(usePlatformLanguage());
